module.exports = __webpack_public_path__ + "assets/img/s1-logo@2x.64599750.png";